import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import './card.scss';
import { Popup } from 'semantic-ui-react';
import Skeleton, {SkeletonTheme } from 'react-loading-skeleton';

class MyCard extends Component {

    constructor(props) {
        super(props);
        this.state = {
          
        }
    }

    componentDidMount()
    {
        
    }

    render() {
        return(
            <div onClick={this.props.onClick}>
                <Popup content={this.props.popupText} position='top center' inverted trigger={
                    <Link to={{pathname: this.props.link,
                            state: {...this.props.linkState,clearStore:true}
                            }}>
                        <div className="card">
                        <section>
                                <h2>
                                    {
                                       (
                                    this.props.metric !== null && this.props.metric !== undefined ? this.props.metric : 
                                    <SkeletonTheme color="#0071b9" highlightColor="#8ebcd2" >
                                        <Skeleton />
                                    </SkeletonTheme>)
                                    }
                                </h2>
                            </section>
                            <section>
                                <p>
                                    {
                                    
                                    (
                                        this.props.title !== null && this.props.title !== undefined ? this.props.title : 
                                    <SkeletonTheme color="#0071b9" highlightColor="#8ebcd2" >
                                        <Skeleton />
                                    </SkeletonTheme> )
                                    }
                                </p>
                            </section>
                        </div>   
                    </Link>
                } />
                            
            </div>
        )

    }

}

export default MyCard;